import { Container } from 'components';
import { isDev, isProd } from 'helpers';
import arionStar from 'img/arion-star.svg';
import logoutImg from 'img/sign_out.svg';
import tileImg from 'img/tile.svg';
import { Link } from 'react-router';
import { useTopBar } from './useTopBar';

export function TopBar() {
	const { changeLanguage, config, isLogged, logout, resetProcesses, state } = useTopBar();
	return (
		<header className="app-header">
			<Container>
				<div className="row">
					<div className="col-12">
						<div className="app-header--row">
							<Link className="relative" to="../onboard">
								<img alt="" className="arion-logo" src={arionStar} />
								<span className="app-header-title">{state.title}</span>
							</Link>
						</div>
						<div className="app-header--row float-right">
							{isLogged && (
								<>
									<span className="d-none d-md-inline me-2">{state.user.givenName}</span>
									{!isProd(config.APP_ENV) && (
										<button
											className="d-none d-sm-inline relative ms-2 btn-link text-white"
											onClick={resetProcesses}
											type="button"
										>
											<img alt="" src={tileImg} />
											<span className="lang-btn">
												<span className="lang-name">X</span>
											</span>
										</button>
									)}
								</>
							)}
							{isDev(config.APP_ENV) && (
								<button className="relative ms-2 btn-link text-white" onClick={changeLanguage} type="button">
									<img alt="" src={tileImg} />
									<span className="lang-btn">
										<span className="lang-name">{state.language.language}</span>
									</span>
								</button>
							)}
							{isLogged && (
								<button className="ms-2 btn-link text-white" onClick={logout} type="button">
									<img alt="" src={logoutImg} />
								</button>
							)}
						</div>
					</div>
				</div>
			</Container>
		</header>
	);
}
